import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { Building } from '~/models/modules/building';
import { ApiServiceBase, API_NAMES } from '~/services/api';



@Injectable({ providedIn: 'root' })
export class BuildingService extends ApiServiceBase {
     buildingClosed: BehaviorSubject<string> = new BehaviorSubject<string>(null);
     BuildingAdded: EventEmitter<any> = new EventEmitter();
     BuildingUpdated: EventEmitter<any> = new EventEmitter();
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    deactivateBuilding(obj: any) {
        return this.client.put(this._url(`/deactivate`), obj);
    }

    getListOfBuilding() {
        return this.http.get<Building[]>(this._url());
    }
    getBuildingBySite(model: any) {
      return this.http.post<any>(this._url(`/getBuildingBySite`), model);
  }

     getBuildingByID(id: number) {
        return this.http.get<Building>(this._url(`/${id}`));
    }


    createBuilding(model: any) {
        return this.client.post<string>(this._url(), model);
    }

      activateAnddeactivateBuildingBatch(obj: any) {
      return this.client.put(this._url(`/batchDeactivate`), obj);
    }

    // reactivateBuilding(obj: any) {
    //   return this.client.put(this._url(`/reactivate`), obj);
    // }


       GetBuildingChart(buildingId : number){
        return this.client.get(this._url(`/Building/${buildingId}/Chart`));
    }

    getBuildingdatagrid(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<Building[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })

            .pipe(map(augmentPaging));
    }

     updateBuilding( model: any) {
        return this.client.put(this._url(), model);
    }



    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/Building${v}`);
    }


    buildingFormClosed(newValue: any) {
        this.buildingClosed.next(newValue);
    }

}
